import XAPPButton from "app/Core/Components/Button/XAPPButton";
import clsx from 'clsx';
import React from "react";

const MensagemIcone = ({ title, className, disabled = true, nome }) => {

    return (
        <React.Fragment>
            <XAPPButton
                tooltip={{ "title": title, "placement": "top" }}
                type="Icon"
                className={clsx("p-6", className)}
                onClick={() => { }}
                noHover={disabled}
                icon={nome}
            />
        </React.Fragment>
    );
}


export default MensagemIcone;